import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  key: 0,
  class: "m-2 p-2 border-2 border-black dark:border-white"
}
const _hoisted_4 = {
  key: 1,
  class: "m-2 p-2 border-2 border-black dark:border-white"
}
const _hoisted_5 = {
  key: 2,
  class: "flex m-2 p-2 border-2 items-center"
}
const _hoisted_6 = { class: "m-2 flex justify-between" }
const _hoisted_7 = { class: "m-2 rounded-2xl" }
const _hoisted_8 = { class: "m-2 p-2 flex justify-center items-center" }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "block md:hidden" }
const _hoisted_11 = {
  key: 0,
  class: "m-4"
}
const _hoisted_12 = {
  key: 1,
  class: "m-4"
}
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "hidden md:block" }
const _hoisted_15 = { class: "flex justify-center m-4" }
const _hoisted_16 = { class: "mt-8" }
const _hoisted_17 = { class: "tw_main" }
const _hoisted_18 = { class: "mt-8 grid grid-cols-2 md:grid-cols-3" }
const _hoisted_19 = { class: "m-2" }
const _hoisted_20 = { class: "flex flex-wrap" }
const _hoisted_21 = { class: "ml-2" }
const _hoisted_22 = {
  href: "https://x.com/GMetaverse",
  target: "_blank"
}
const _hoisted_23 = { class: "ml-2" }
const _hoisted_24 = {
  href: "https://www.threads.com/@gotothemetaverse",
  target: "_blank"
}
const _hoisted_25 = { class: "ml-2" }
const _hoisted_26 = {
  href: "https://discord.com/channels/929203794871468092/1356192245975613553",
  target: "_blank"
}
const _hoisted_27 = { class: "ml-2" }
const _hoisted_28 = {
  href: "https://www.youtube.com/@%EC%9D%B4%EB%A0%87%EA%B2%8C%EB%90%9C%EC%9D%B4%EC%83%81%EB%A9%94%ED%83%80%EB%B2%84%EC%8A%A4/",
  target: "_blank"
}
const _hoisted_29 = { class: "ml-2" }
const _hoisted_30 = {
  href: "https://addforce1.blogspot.com/",
  target: "_blank"
}
const _hoisted_31 = { class: "m-2 flex justify-end items-center" }
const _hoisted_32 = { class: "font-bold" }
const _hoisted_33 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_34 = { class: "ml-2 text-xs" }
const _hoisted_35 = {
  key: 1,
  class: "ml-2 text-xs"
}
const _hoisted_36 = { class: "ml-2 h-6 items-end" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 1,
  src: "https://myhits.vercel.app/api/hit/https%3A%2F%2Fapps.sidnft.com?color=blue&label=hits&size=small&base_count=1"
}

import * as Vue from "vue";
import { motion } from "motion-v";
import { useRoute, useRouter } from "vue-router";
import { useDark, useStorage, useToggle } from "@vueuse/core";
import { Icon } from "@iconify/vue";
import { VERSION, BUILD_DATE } from "@/ver";
import moment from "moment";
import im2 from "@/components/Img2.vue";
import * as Helper from "./helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// App.vue
Icon;

const URL_HEAD = Helper.get_url_head();

// 사용할 지갑 목록 (Petra 등 설치 필요)
const IS_DEV = Helper.is_dev();
const route = useRoute();
const router = useRouter();
// const store = Helper.useStore();
const store = Helper.usePinia();
const is_dark = useDark();
const toggle_dark = useToggle(is_dark);
const need_refresh = Vue.ref(false);

const is_dev = Vue.ref(true);
if (Helper.is_dev()) {
  // console.log("is_dev");
} else {
  is_dev.value = false;
  console.log = () => {};
  console.info = () => {};
  console.error = () => {};
}

const page = Vue.ref({
  //
  need_update: false,
  is_show_menus: false,
});

const top_menu_list = Vue.ref([
  {
    label: "HOME",
    to: "/",
  },
  {
    label: "DEV LOG",
    to: "/works",
  },
  {
    label: "DEV-NEWS (KR)",
    to: "/news",
  },
]);

//
const menu_class = (data) => {
  // console.log("menu_class start", data);

  var base = "tw_menu_item";
  if (is_dark.value) {
    base = "tw_menu_item_dark";
  }

  var enable = "";
  if (data.to == route.fullPath) {
    enable = "tw_menu_disabled";
    if (is_dark.value) {
      enable = "tw_menu_disabled_dark";
    }
  }

  var ret = base + " " + enable;
  // console.log("class", data.to, ret);
  return ret;
};


// const is_enable = (input) => {
//   //console.log("is_enable", route.fullPath, input);
//   if (input == route.fullPath) {
//     return "tw-border";
//   }
//   return "";
// };

const onPush = (to: string) => {
  setTimeout(() => {
    router.push(to);
  }, 500);
};

const onToggleDark = () => {
  setTimeout(() => {
    if (toggle_dark) {
      toggle_dark.apply(undefined);
    }
  }, 100);
};

const time_count = Vue.computed(() => {
  // var v = pinia.doubleCount;
  // console.log("count", v);
  // return v;
  return store.count;
});

Vue.onMounted(async () => {
  console.log("App onMounted start");

  if (VERSION + 1 == 0) {
    console.log("skip warning", VERSION, BUILD_DATE);
  }

  // 엡 초기화
  // store.commit("app_init");
  store.app_init();

  // onFirst
  var url = URL_HEAD + "/api/ver_release/apps";
  var res_data = await Helper.web_get(url);
  var data = res_data.data;
  // console.log("ver_release res", data);

  // db 시간차이 저장
  Helper.set_dbdate_offset(data.dbdate_offset);

  // console.log("data", data);
  if (data.code != 200) {
    throw new Error("ver_release fail");
  }
  if (typeof data.release_ver != "number") {
    throw new Error("ver_release fail");
  }

  // console.log("check_version", VERSION, data.release_ver);
  // console.log("check_version", data);
  if (VERSION < data.release_ver) {
    page.value.need_update = true;
  }

  console.log("App onMounted end");
});

const onRefresh = () => {
  console.log("onRefresh");
  window.location.reload();
};

const onPageReload = () => {
  location.reload();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mt-10" }, null, -1)),
      (_unref(is_dev))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " DEV MODE "))
        : _createCommentVNode("", true),
      (_unref(page).need_update)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createTextVNode(" NEED UPDATE PAGE ")),
            _createElementVNode("button", {
              class: "ml-4",
              onClick: onPageReload
            }, "RELOAD")
          ]))
        : _createCommentVNode("", true),
      (_unref(need_refresh))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("div", null, "NEED REFRESH PAGE", -1)),
            _createElementVNode("div", { class: "ml-8 tw_button" }, [
              _createElementVNode("button", { onClick: onRefresh }, "REFRESH")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _cache[6] || (_cache[6] = _createElementVNode("div", null, [
          _createElementVNode("h1", null, "SIDNFT")
        ], -1)),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(motion).button, {
              "while-hover": { scale: 2.0 },
              "while-press": { scale: 0.8 },
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onToggleDark())),
              class: "flex justify-center items-center"
            }, {
              default: _withCtx(() => [
                (_unref(is_dark))
                  ? (_openBlock(), _createBlock(_unref(Icon), {
                      key: 0,
                      icon: "material-symbols:sunny",
                      class: "w-8 h-8"
                    }))
                  : (_openBlock(), _createBlock(_unref(Icon), {
                      key: 1,
                      icon: "material-symbols:dark-mode",
                      class: "w-8 h-8"
                    }))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(motion).button, {
          "while-hover": { scale: 1.5 },
          "while-press": { scale: 0.8 },
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onPush('/'))),
          class: "flex items-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Icon), {
              class: "w-16 h-16",
              icon: "basil:app-store-outline"
            }),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-4xl" }, "pps", -1))
          ]),
          _: 1
        })
      ]),
      true
        ? (_openBlock(), _createElementBlock("nav", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_unref(page).is_show_menus == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(page).is_show_menus = true))
                    }, "☰ SHOW MENUS")
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(page).is_show_menus = false))
                      }, "✖ HIDE MENUS")
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(top_menu_list), (data) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: data.to,
                          class: _normalizeClass(menu_class(data))
                        }, [
                          _createVNode(_component_router_link, {
                            to: data.to
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(data.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ], 2))
                      }), 128))
                    ])
                  ]))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(top_menu_list), (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: data.to,
                    class: _normalizeClass(menu_class(data))
                  }, [
                    _createVNode(_component_router_link, {
                      to: data.to
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ], 2))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("main", _hoisted_17, [
          _createVNode(_component_router_view)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"m-2\"><div class=\"text-xl font-bold\">SIDNFT</div><div class=\"ml-4\"><a href=\"/sidnft_policy\"> PRIVACY POLICY </a></div><div class=\"ml-4\"><a href=\"/sidnft_service\"> SERVICE POLICY</a></div></div>", 1)),
        _createElementVNode("div", _hoisted_19, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-xl font-bold flex justify-start items-center" }, [
            _createElementVNode("div", null, "SNS")
          ], -1)),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("a", _hoisted_22, [
                _createVNode(_unref(Icon), {
                  class: "tw_icon",
                  icon: "ri:twitter-x-fill"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("a", _hoisted_24, [
                _createVNode(_unref(Icon), {
                  class: "tw_icon",
                  icon: "ri:threads-fill"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("a", _hoisted_26, [
                _createVNode(im2, {
                  class: "tw_icon",
                  src: "/images/discord_icon.png"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("a", _hoisted_28, [
                _createVNode(_unref(Icon), {
                  class: "tw_icon",
                  icon: "ri:youtube-fill"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("a", _hoisted_30, [
                _createVNode(_unref(Icon), {
                  class: "tw_icon",
                  icon: "ri:blogger-fill"
                })
              ])
            ])
          ])
        ]),
        _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"m-2\"><div class=\"text-xl font-bold\">PROJECTS</div><div class=\"ml-4\"><a href=\"https://bitaxe.sidnft.com/\" target=\"_blank\">BITAXE</a></div><div class=\"ml-4\"><a href=\"https://room.sidnft.com/\" target=\"_blank\">ROOM</a></div><div class=\"ml-4\"><a href=\"https://www.aivtuber.kro.kr/\" target=\"_blank\">AIV</a></div></div>", 1))
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, "v" + _toDisplayString(_unref(VERSION)), 1),
        (_unref(is_dev))
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, "DEV"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, "(" + _toDisplayString(_unref(moment)(_unref(BUILD_DATE)).fromNow()) + ")", 1),
        (_unref(is_dev))
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, "c:" + _toDisplayString(_unref(time_count)), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_36, [
          (_unref(IS_DEV))
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, "DEV_NO_COUNTER"))
            : (_openBlock(), _createElementBlock("iframe", _hoisted_38))
        ])
      ])
    ])
  ]))
}
}

})